import { Contract } from '@mobi/web-native-comms'
import * as apiService from '@core/Services/ApiService'
import { togglePushNotificationAlertStatus } from '@core/Utils/notifications/pushNotificationAlerts'

export interface AuthStatus {
  deviceId?: Contract['RESPONSE_PUSH_AUTH_STATUS']['deviceId']
  status?: Contract['RESPONSE_PUSH_AUTH_STATUS']['status']
  accountNumber: number
  lastUpdated: Date
}

export function updatePushNotificationsAuthStatus(body: AuthStatus) {
  if (body.status === 'Authorized') {
    togglePushNotificationAlertStatus({
      accountNumber: body.accountNumber,
      isEnabled: true,
      alertType: 'followme',
      deepLink: '',
    })
  }
  return apiService.post<AuthStatus>({
    url: '/api/account/updatePushNotificationsAuthStatus',
    body,
  })
}
